import { Breakpoint, Color, EventTile } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 16px 40px;
  gap: 40px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 64px 80px 80px;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
`;

export const RequiredLessonsWrapper = styled.div`
  width: 100%;
  margin-top: 48px;
  padding: 40px 0;
  border-top: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};

  @media ${Breakpoint.SmallDesktop} {
    border-top: none;
  }
`;

export const StyledEventCard = styled(EventTile)`
  width: 285px;
  height: 100%;
`;
